<div nz-row>
  <div nz-col nzXs="24" nzSm="24" nzMd="8" nzLg="8" nzXl="8" class="mt-lg pr-lg">

    <nz-card class="offline-card mt-lg">
      <ng-container [ngSwitch]="value.screen">
        <ng-container *ngSwitchCase="'declaration'">
          <div nz-row class="listStyle">
            <div *ngIf="value?.type?.length <= 0" nz-col nzSpan="12">{{'base-shared.base-preview.declaration-code' | translate}}</div>
            <div *ngIf="value?.type?.length > 0" nz-col nzSpan="12">{{'base-shared.base-preview.cargoesTransfer-code' | translate}}</div>
            <div nz-col nzSpan="12" (click)="viewDeclaration()">
              <a>{{value.previewData.tgData.referenceCode}}</a>
            </div>
          </div>
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">{{'base-shared.base-preview.regime' | translate}}</div>
            <div nz-col nzSpan="12">{{getRdmDataByRefTypeAndCode("tred8323",value.previewData.tgData.regime)}}</div>
          </div>
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">{{'base-shared.base-preview.procedure' | translate}}</div>
            <div nz-col nzSpan="12">{{getRdmDataByRefTypeAndCode("umscodes7365",value.previewData.tgData.procedure)}}</div>
          </div>
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">{{'base-shared.base-preview.mode-of-transport' | translate}}</div>
            <div nz-col nzSpan="12"
              *ngIf="getRdmDataByRefTypeAndCode('tred8067',value.previewData.tgData.modeOfTransport) === 'Transport mode not specified' else showIcon">
              {{'base-shared.base-preview.transport-mode-not-specified' | translate}} </div>
            <ng-template #showIcon>
              <cargoes-business-icons [defaultFormData]="getRdmDataByRefTypeAndCode('tred8067',value.previewData.tgData.modeOfTransport)">
              </cargoes-business-icons>
            </ng-template>
          </div>
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">{{'base-shared.base-preview.number-Of-lines' | translate}}</div>
            <div nz-col nzSpan="12">{{value.previewData.tgData.noOfLines}}</div>
          </div>
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">{{'base-shared.base-preview.number-Of-containers' | translate}}</div>
            <div nz-col nzSpan="12">{{value.previewData.tgData.noOfContainers}}</div>
          </div>
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">{{'base-shared.base-preview.customs-office' | translate}}</div>
            <div nz-col nzSpan="12">{{getRdmDataByRefTypeAndCode('ics-customs-office',value.previewData.tgData.goodsLocation)}}</div>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'manifest'">
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">{{'base-shared.base-preview.manifest-reference-code' | translate}}</div>
            <div nz-col nzSpan="12" (click)="viewDeclaration()">
              <a>{{value.previewData.tgData.referenceCode}}</a>
            </div>
          </div>
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">{{'base-shared.base-preview.movement-code' | translate}}</div>
            <div nz-col nzSpan="12">{{getRdmDataByRefTypeAndCode("umsmovement",value.previewData.tgData.regime)}}</div>
          </div>
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">{{'base-shared.base-preview.number-of-transport-documents' | translate}}</div>
            <div nz-col nzSpan="12">{{value.previewData.tgData.noOfTransportDoc}}</div>
          </div>
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">{{'base-shared.base-preview.mode-of-transport' | translate}}</div>
            <div nz-col nzSpan="12" *ngIf="getRdmDataByRefTypeAndCode('tred8067',value.previewData.tgData.modeOfTransport) === 'Transport mode not specified' else showIcon">Transport mode not specified </div>
            <ng-template #showIcon>
              <cargoes-business-icons [defaultFormData]="getRdmDataByRefTypeAndCode('tred8067',value.previewData.tgData.modeOfTransport)"></cargoes-business-icons>
            </ng-template>
          </div>
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">{{'base-shared.base-preview.submitter' | translate}}</div>
            <div nz-col nzSpan="12">{{value.previewData.tgData.submitterName}}</div>
          </div>
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">{{'base-shared.base-preview.number-Of-lines' | translate}}</div>
            <div nz-col nzSpan="12">{{value.previewData.tgData.noOfLines}}</div>
          </div>
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">{{'base-shared.base-preview.number-Of-containers' | translate}}</div>
            <div nz-col nzSpan="12">{{value.previewData.tgData.noOfContainers}}</div>
          </div>
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">{{'base-shared.base-preview.customs-office' | translate}}</div>
            <div nz-col nzSpan="12">{{getRdmDataByRefTypeAndCode('ics-customs-office',value.previewData.tgData.submissionOffice)}}</div>
          </div>
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">{{'base-shared.base-preview.date-of-arrival' | translate}}</div>
            <div nz-col nzSpan="12">{{value.previewData.tgData.dateOfarrival}}</div>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'passenger-manifest'">
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">Passenger Manifest No.</div>
            <div nz-col nzSpan="12" >
              {{value.previewData.tgData.referenceCode}}
            </div>
          </div>
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">Transport Type</div>
            <div nz-col nzSpan="12">{{getRdmDataByRefTypeAndCode("ics_passenger_trasportType",value.previewData.tgData.modeOfTransport)}}</div>
          </div>
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">No. Of Passenger</div>
            <div nz-col nzSpan="12">{{value.previewData.tgData.noOfLines}}</div>
          </div>
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">{{'Label.manifest.passenger.header.inboundOutbound' | translate}}</div>
            <div nz-col nzSpan="12" >{{value.previewData.tgData.movementCode}} </div>
            <ng-template #showIcon>
              <cargoes-business-icons [defaultFormData]="getRdmDataByRefTypeAndCode('tred8067',value.previewData.tgData.mode)"></cargoes-business-icons>
            </ng-template>
          </div>
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">{{'base-shared.base-preview.customs-office' | translate}}</div>
            <div nz-col nzSpan="12">{{getRdmDataByRefTypeAndCode('ics-customs-office',value.previewData.tgData.goodsLocation)}}</div>
          </div>
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">Created Date</div>
            <div nz-col nzSpan="12">{{value.previewData.tgData.createdDate}}</div>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'passenger-declaration'">
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">Passenger Declaration No.</div>
            <div nz-col nzSpan="12" (click)="viewDeclaration()">
              <a>{{value.previewData.tgData.referenceCode}}</a>
            </div>
          </div>
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">Transport Type</div>
            <div nz-col nzSpan="12">{{getRdmDataByRefTypeAndCode("ics_passenger_trasportType",value.previewData.tgData.modeOfTransport)}}</div>
          </div>
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">No. Of Items</div>
            <div nz-col nzSpan="12">{{value.previewData.tgData.noOfLines}}</div>
          </div>
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">{{'Officer In Charge' | translate}}</div>
            <div nz-col nzSpan="12" >{{value.previewData.tgData.submitterName}} </div>
          </div>
          <!-- <div nz-row class="listStyle">
            <div nz-col nzSpan="12">{{'base-shared.base-preview.customs-office' | translate}}</div>
            <div nz-col nzSpan="12">{{getRdmDataByRefTypeAndCode('ics-customs-office',value.previewData.tgData.goodsLocation)}}</div>
          </div> -->
          <div nz-row class="listStyle">
            <div nz-col nzSpan="12">{{'Submission Date' | translate}}</div>
            <div nz-col nzSpan="12">{{value.previewData.tgData.acceptanceDateTime}}</div>
          </div>
        </ng-container>
      </ng-container>


    </nz-card>
  </div>

  <div nz-col nzXs="24" nzSm="24" nzMd="16" nzLg="16" nzXl="16" class="mt-lg pl-lg">
    <div id="risktScore" class="bg-w"></div>
  </div>
</div>
<nz-card class="mt-lg">
  <nz-table #nestedTable [nzData]="value.previewData.tData" [nzPageSize]="10">
    <thead>
      <tr>
        <th nzWidth="115px" class="tbl-color1">{{'base-shared.base-preview.profile-code' | translate}}</th>
        <th nzWidth="85px" class="tbl-color1">{{'base-shared.base-preview.risk-area' | translate}}</th>
        <th nzWidth="85px" class="tbl-color1">{{'base-shared.base-preview.category' | translate}}</th>
        <th nzWidth="185px" class="tbl-color1">{{'base-shared.base-preview.rule' | translate}}</th>
        <th nzWidth="115px" class="tbl-color1">{{'base-shared.base-preview.risk-owner' | translate}}</th>
        <th nzWidth="45px" class="tbl-color1">{{'base-shared.base-preview.score' | translate}}</th>
        <th nzWidth="95px" class="tbl-color1">{{'base-shared.base-preview.inspection-action' | translate}}</th>
        <ng-container [ngSwitch]="value.screen">
          <ng-container *ngSwitchCase="'declaration'">
            <th nzWidth="45px" nzRight="0px" class="tbl-color1" *ngIf="value?.type?.length <=0">{{'base-shared.base-preview.item' | translate}}</th>
          </ng-container>
          <ng-container *ngSwitchCase="'manifest'">
            <th nzWidth="70px" class="tbl-color1">{{'base-shared.base-preview.bol-info' | translate}}</th>
          </ng-container>
          <ng-container *ngSwitchCase="'passenger-manifest'">
            <th nzWidth="45px" nzRight="0px" class="tbl-color1" >Passenger Info</th>
          </ng-container>
          <ng-container *ngSwitchCase="'passenger-declaration'">
            <th nzWidth="45px" nzRight="0px" class="tbl-color1">{{'base-shared.base-preview.item' | translate}}</th>
          </ng-container>
        </ng-container>
        <th nzWidth="100px" class="tbl-color1" *ngIf="value.screen === 'manifest'">Container Details</th>
        <th nzWidth="75px" class="tbl-color1">{{'base-shared.base-preview.recommended-action' | translate}}</th>
        <th nzWidth="75px" class="tbl-color1" *ngIf="value.screen === 'declaration'">{{'base-shared.base-preview.source' | translate}}</th>
      </tr>
    </thead>
    <tbody class="tbl-color2">
      <ng-template ngFor let-data [ngForOf]="nestedTable.data" let-i="index">
        <tr>
          <td *ngIf="(value.screen !== 'passenger-manifest' && value.screen !== 'passenger-declaration' )"><a id="viewProfile" (click)="viewProfile(data.ruleId)">{{data.profileCode}}</a></td>
          <td *ngIf="(value.screen === 'passenger-manifest' || value.screen === 'passenger-declaration' )">{{data.profileCode}}</td>
          <td>{{data.trs}}</td>
          <td>{{getRdmDataByRefTypeAndCode('kc-profile-category-code',data.categoryCode)}}</td>
          <td>{{data.ruleDetails}}</td>
          <td>{{data.riskRuleOwner}}</td>
          <td>{{data.finalScore}}</td>
          <td> <cargoes-business-icons [defaultFormData]="data?.inspectionCaseAction"></cargoes-business-icons></td>
          <td nzShowExpand [(nzExpand)]="data.expand"></td>
          <td nzShowExpand [(nzExpand)]="data.containers" *ngIf="value.screen === 'manifest'"></td>
          <td [nzShowExpand]= "(data.recomendedAction !== null)? true : false"  [(nzExpand)]="data.rAction"></td>
          <td *ngIf="value.screen === 'declaration'"><a id="viewNews" (click)="viewExternalSourceRiskInforPopup(data)">{{data.source}}</a></td>
        </tr>
        <tr [nzExpand]="data.expand">
          <ng-container *ngIf="(data.riskAssItemsDetailsList && data.riskAssItemsDetailsList.length > 0) ||
            (data.riskAssTransportDocInfo && data.riskAssTransportDocInfo.length > 0) ">
            <ng-container [ngSwitch]="value.screen">
              <ng-container *ngSwitchCase="'declaration'">
                <nz-table class="inner-table" #innerTable [nzData]="data.riskAssItemsDetailsList" [(nzPageIndex)]="pageIndex" [(nzPageSize)]="pageSize" [nzShowPagination]="data?.riskAssItemsDetailsList?.length >=pageSize">
                  <thead>
                    <tr>
                      <th class="tbl-color3">#</th>
                      <th class="tbl-color3">{{'base-shared.base-preview.sequence-number' | translate}}</th>
                      <th class="tbl-color3">{{'base-shared.base-preview.hs-code' | translate}}</th>
                      <th class="tbl-color3">{{'base-shared.base-preview.score' | translate}}</th>
                      <th class="tbl-color3">{{'base-shared.base-preview.description' | translate}}</th>
                    </tr>
                  </thead>
                  <tbody class="tbl-color4">
                    <tr *ngFor="let data of innerTable.data; let i = index">
                      <td>{{ pageSize * (pageIndex-1) + i+1 }}</td>
                      <td>{{data?.sequenceNo}}</td>
                      <td>{{data?.comodityCode}}</td>
                      <td>{{data?.score}}</td>
                      <td>{{data?.description}}</td>
                    </tr>
                  </tbody>
                </nz-table>
              </ng-container>
              <ng-container *ngSwitchCase="'passenger-manifest'">
                <nz-table class="inner-table" #innerTable [nzData]="data.riskAssItemsDetailsList" [nzShowPagination]="false">
                  <thead>
                    <tr>
                      <th class="tbl-color3">#</th>
                      <th class="tbl-color3">Name</th>
                      <th class="tbl-color3">Nationality</th>
                      <th class="tbl-color3">Gender</th>
                      <th class="tbl-color3">Document Type</th>
                      <th class="tbl-color3">Document Type</th>
                    </tr>
                  </thead>
                  <tbody class="tbl-color4">
                    <tr *ngFor="let data of innerTable.data; let i = index">
                      <td>{{i+1}}</td>
                      <td>{{data?.sequenceNo}}</td>
                      <td>{{data?.comodityCode}}</td>
                      <td>{{data?.comodityCode}}</td>
                      <td>{{data?.score}}</td>
                      <td>{{data?.description}}</td>
                    </tr>
                  </tbody>
                </nz-table>
              </ng-container>
              <ng-container *ngSwitchCase="'passenger-declaration'">
                <nz-table class="inner-table" #innerTable [nzData]="data.riskAssItemsDetailsList" [nzShowPagination]="false">
                  <thead>
                    <tr>
                      <th class="tbl-color3">#</th>
                      <th class="tbl-color3">{{'base-shared.base-preview.hs-code' | translate}}</th>
                      <th class="tbl-color3">{{'base-shared.base-preview.score' | translate}}</th>
                      <th class="tbl-color3">{{'base-shared.base-preview.description' | translate}}</th>
                    </tr>
                  </thead>
                  <tbody class="tbl-color4">
                    <tr *ngFor="let data of innerTable.data; let i = index">
                      <td>{{i+1}}</td>
                      <td>{{data?.comodityCode}}</td>
                      <td>{{data?.score}}</td>
                      <td>{{data?.description}}</td>
                    </tr>
                  </tbody>
                </nz-table>
              </ng-container>
              <ng-container *ngSwitchCase="'manifest'">
                <nz-table class="table-padded" #innerTable [nzData]="data.riskAssTransportDocInfo" [nzShowPagination]="false">
                  <thead >
                    <tr>
                      <th class="tbl-color3">#</th>
                      <th class="tbl-color3">BOL Number</th>
                      <th class="tbl-color3">Regime</th>
                      <th class="tbl-color3">Score</th>
                      <th class="tbl-color3">Description</th>
                      <th class="tbl-color3" nzWidth="185px">Items</th>
                    </tr>
                  </thead>
                  <tbody class="tbl-color4">
                    <ng-container *ngFor="let data of innerTable.data; let i = index">
                    <tr>
                      <td>{{data?.sequenceNo}}</td>
                      <td>{{data?.bolNumber}}</td>
                      <td>{{getRdmDataByRefTypeAndCode('tred8323',data.regimeType)}}</td>
                      <td>{{data?.score}}</td>
                      <td>{{data?.description}}</td>
                      <td nzShowExpand [(nzExpand)]="data.goods"></td>
                    </tr>
                    <tr></tr>
                    <tr [nzExpand]="data.goods">
                        <nz-table class="table-padded" #goodTable [nzData]="data.riskAssGoodsInfo" [nzShowPagination]="false">
                          <thead >
                            <tr>
                              <th class="tbl-color5">#</th>
                              <th class="tbl-color5">H.S. Code</th>
                              <th class="tbl-color5">Description</th>
                              <th class="tbl-color5"></th>
                              <th class="tbl-color5"></th>
                           </tr>
                          </thead>
                          <tbody class="tbl-color6">
                            <tr *ngFor="let data of goodTable.data; let i = index">
                              <td>{{data?.sequenceNo}}</td>
                               <td>{{data?.comodityCode}}</td>
                              <td>{{data?.description}}</td>
                              <td></td>
                              <td></td>
                            </tr>
                          </tbody>
                        </nz-table>
                    </tr>
                  </ng-container>
                  </tbody>
                </nz-table>
              </ng-container>
            </ng-container>

          </ng-container>
          <ng-container *ngIf="(!data.riskAssItemsDetailsList || data.riskAssItemsDetailsList.length === 0) && (!data.riskAssTransportDocInfo || data.riskAssTransportDocInfo.length === 0)">
            <div class="text-center">
              <h3>{{'base-shared.base-preview.no-data' | translate}}</h3>
            </div>
          </ng-container>
        </tr>
        <tr [nzExpand]="data.containers">
          <ng-container *ngIf="(data.riskAssTransportDocInfo[0] && data.riskAssTransportDocInfo[0].riskAssContainerInfo && data.riskAssTransportDocInfo[0].riskAssContainerInfo.length > 0)">
              <ng-container>
                <nz-table class="table-padded" #basicTable [nzData]="data.riskAssTransportDocInfo[0].riskAssContainerInfo" [nzShowPagination]="false">
                  <thead >
                    <tr>
                      <th class="tbl-color5">Container Number</th>
                      <th class="tbl-color5">Container Status</th>
                      <th class="tbl-color5">Number of Seals</th>
                      <th class="tbl-color5">Detail</th>
                   </tr>
                  </thead>
                  <tbody class="tbl-color6">
                    <tr *ngFor="let row of basicTable.data; let i = index">
                      <td>{{row.containerNumber}}</td>
                      <td>{{getRdmDataByRefTypeAndCode('tred8249',row.containerStatus)}}</td>
                      <td>{{row.numberOfSeals}}</td>
                      <td>  <a id="viewRoute" (click)="popup.openDialogue(value.previewData.tgData.referanceId,row.containerNumber)">
                        <i nz-icon nzType="eye" nzTheme="outline"></i>
                      </a>
                    </td>
                    </tr>
                  </tbody>
                </nz-table>
              </ng-container>
          </ng-container>
          <ng-container *ngIf="!(data.riskAssTransportDocInfo[0] && data.riskAssTransportDocInfo[0].riskAssContainerInfo && data.riskAssTransportDocInfo[0].riskAssContainerInfo.length > 0)">
            <!-- <ng-container *ngIf="(!(data.riskAssTransportDocInfo[0] && data.riskAssTransportDocInfo[0].riskAssContainerInfo)  || data.riskAssTransportDocInfo[0].riskAssContainerInfo.length === 0) && (!data.riskAssTransportDocInfo || data.riskAssTransportDocInfo.length === 0)"> -->
            <div class="text-center">
              <h3>{{'base-shared.base-preview.no-data' | translate}}</h3>
            </div>
            </ng-container>
        </tr>
        <!-- Recommended Action -->
        <tr [nzExpand]="data.rAction">
          <ng-container *ngIf="data.recomendedAction && data.recomendedAction.length > 0 ">
            <nz-list nzBordered [nzDataSource]="splitRecomndedAction(data.recomendedAction)"
              [nzRenderItem]="defaultItem">
              <ng-template #defaultItem let-item>
                <nz-list-item class="tbl-color7">
                  {{getRdmDesc(item)}}
                </nz-list-item>
              </ng-template>
            </nz-list>
          </ng-container>
        </tr>
      </ng-template>
    </tbody>
  </nz-table>
</nz-card>

<route-map-detail-pop-up #popup></route-map-detail-pop-up>

<nz-modal [(nzVisible)]="isExternalSourcePopupVisible" [nzTitle]="modalTitle" [nzContent]="modalContent" [nzFooter]="modalFooter"
  (nzOnCancel)="closeExternalSourceRiskInfoDialogue()" (nzOnOk)="closeExternalSourceRiskInfoDialogue()" nzBlockNode nzWidth="75%">
  <ng-template #modalTitle>
    News
  </ng-template>

  <ng-template #modalContent>
    <ng-container>
      <map-view [markers]="markers"></map-view>
    </ng-container>

  </ng-template>
  <ng-template #modalFooter>
    <button nz-button nzType="primary" (click)="closeExternalSourceRiskInfoDialogue()">Close</button>
  </ng-template>
</nz-modal>
